
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskActionType } from 'enums/TaskActionType';
import { Model, ModelProperty } from 'models/Model';


export class CreateTaskActionWithNewTaskflowRequestModel extends Model<CreateTaskActionWithNewTaskflowRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'logComments', type: 'string', languageString: 'createTaskActionWithNewTaskflowRequest.property.logComments' },
		{ name: 'logEntryStatus', type: 'string', languageString: 'createTaskActionWithNewTaskflowRequest.property.logEntryStatus' },
		{ name: 'followUpDate', type: 'Date', languageString: 'createTaskActionWithNewTaskflowRequest.property.followUpDate' },
		{ name: 'followUpTaskType', type: 'TaskActionType', languageString: 'createTaskActionWithNewTaskflowRequest.property.followUpTaskType' },
		{ name: 'taskflowTag', type: 'string', languageString: 'createTaskActionWithNewTaskflowRequest.property.taskflowTag' },
		{ name: 'companyId', type: 'guid', languageString: 'createTaskActionWithNewTaskflowRequest.property.companyId' },
		{ name: 'dateOnly', type: 'boolean', languageString: 'createTaskActionWithNewTaskflowRequest.property.dateOnly' },
		{ name: 'mailData', type: 'string', languageString: 'createTaskActionWithNewTaskflowRequest.property.mailData' }
	];
	[key: string]: any;
	
	public logComments: string;
	public logEntryStatus?: string;
	public followUpDate?: Date;
	public followUpTaskType: TaskActionType;
	public taskflowTag: string;
	public companyId?: string;
	public dateOnly: boolean;
	public mailData: string;
    
	constructor(){
		super();
		this.logComments = '';
		this.logEntryStatus = undefined;
		this.followUpDate = undefined;
		this.followUpTaskType = 0;
		this.taskflowTag = '';
		this.companyId = undefined;
		this.dateOnly = false;
		this.mailData = '';
		
	}
	getProperties(){
		return CreateTaskActionWithNewTaskflowRequestModel.classProperties;
	}
}

